import { render, staticRenderFns } from "./insuranceCategoryPicker.vue?vue&type=template&id=2683453c&scoped=true"
import script from "./insuranceCategoryPicker.vue?vue&type=script&lang=js"
export * from "./insuranceCategoryPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2683453c",
  null
  
)

export default component.exports